import { useEffect } from 'react';

import { useLocationQuery } from 'lib/hooks/use-query';
import { useModal } from 'components/modal-views/context';

const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const view = useLocationQuery('register_view');
  const { openModal } = useModal();

  useEffect(() => {
    if (view !== null) {
      openModal('REGISTER_VIEW');
    }
  }, []);

  return <>{children}</>;
};

export default PublicRoute;
